<template>
  <el-dialog
    :title="$t('member.tab.memberInfo.debindPhoneTitle')"
    :visible="show"
    width="400px"
    :close-on-click-modal="false"
    @close="$emit('update:show', false)"
  >
    <div>
      {{ $t('member.tab.memberInfo.debindPhoneContent') }}
    </div>
    <div class="btn-container">
      <BaseElButton
        style="width: 140px"
        plain
        @click="$emit('update:show', false)"
      >
        {{ $t('member.tab.memberInfo.cancel') }}
      </BaseElButton>
      <BaseElButton
        style="width: 140px"
        type="primary"
        @click="$emit('debind')"
      >
        {{ $t('member.tab.memberInfo.confirm') }}
      </BaseElButton>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'DeBindPhoneWarningDialog',
  props: ['show'],
  computed: {
    shop () {
      return this.$store.getters.shop
    },
  },
  methods: {
    async deleteAuthPhone () {
      this.$emit('debind')
    },
  },
}
</script>

<style lang="postcss" scoped>
.btn-container {
  @apply mt-[40px] flex justify-between;
}
</style>
